/**
 * Import required libraries
 */
import React, { useCallback } from "react";
import { connect } from "react-redux";

/**
 * Import required elements
 */
import AppBarRender from "./render";

/**
 * AppBar Component
 */
function AppBar(props) {
  const { dispatch, authenticated, navigation, navmenu } = props;

  const openNavmenu = useCallback(event => {
    event.preventDefault();
    dispatch({
      type: "OPEN_NAVMENU",
      open: !navmenu.open
    });
  }, [dispatch, navmenu.open])

  return React.createElement(AppBarRender, {
    authenticated,
    navigation,
    navmenu,
    openNavmenu,
    dispatch
  });
}

/**
 * Export component
 */
// map redux state to props
export default connect(state => ({
  authenticated: state.user.authenticated,
  navmenu: state.locale.navmenu,
  navigation: state.window.navigation
}))(AppBar);
